var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.962 31.0329C46.962 29.9362 46.8648 28.8951 46.6982 27.8817H31.0119V34.1424H39.9934C39.5908 36.1969 38.4108 37.9321 36.6618 39.112V43.2765H42.0201C45.1574 40.3752 46.962 36.0997 46.962 31.0329Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0119 47.3162C35.5096 47.3162 39.2715 45.8169 42.0201 43.2766L36.6618 39.1121C35.1626 40.1116 33.2608 40.7224 31.0119 40.7224C26.667 40.7224 22.9883 37.7933 21.6695 33.837H16.1446V38.1265C18.8793 43.5681 24.5014 47.3162 31.0119 47.3162Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6695 33.837C21.3225 32.8375 21.142 31.7686 21.142 30.658C21.142 29.5475 21.3363 28.4786 21.6695 27.4791V23.1897H16.1446C15.0063 25.4385 14.3539 27.965 14.3539 30.658C14.3539 33.3511 15.0063 35.8776 16.1446 38.1264L21.6695 33.837Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0119 20.5938C33.469 20.5938 35.6623 21.4406 37.3975 23.0925L42.1451 18.345C39.2715 15.6519 35.5096 14 31.0119 14C24.5014 14 18.8793 17.7481 16.1446 23.1897L21.6695 27.4791C22.9883 23.5229 26.667 20.5938 31.0119 20.5938Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.3161,
    height: 33.3161,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.950acdf280aaef3c083dee012f3ce8c0.svg";
export { ForwardRef as ReactComponent };